<div class="flex flex-col gap-medpace">
    @for (error of formGroup().controls.transfers.errors | keyvalue; track error.key) {
        <medpace-alert [appearance]="'danger'" [content]="error.value" />
    }
    @for (transferFormGroup of formGroup().controls.transfers.controls; track $index) {
        <medpace-transfer-data
            [index]="$index"
            [mode]="'edit'"
            [timeOptions]="timeOptions()"
            [formGroup]="transferFormGroup"
            (removeEvent)="removeTransfer($event)"
        />
    }
    <mds-button
        id="add-transfer-button"
        data-cy="add-transfer-button"
        [label]="'Add transfer'"
        [color]="'primary'"
        [variant]="'tonal'"
        [width]="'100%'"
        (clickEvent)="addTransfer()"
    />
    <medpace-textarea-autocomplete
        id="specialRequests"
        [formCtrl]="formGroup().controls.specialRequests"
        [cdkAutosizeMaxRows]="20"
        [cdkAutosizeMinRows]="5"
        [label]="'Special Requests'"
        [placeholder]="'Special requests - e.g. ADA accessible'"
        [appearance]="'outline'"
        [autoSize]="true"
        [options]="autocompleteOptions().specialRequests"
    />
</div>
